import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '@/components/LanguageSwitcher';

export default function V2Footer() {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-[var(--border)] bg-[var(--surface)] mt-8">
      <div className="max-w-3xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-center justify-between gap-3 text-[11px] text-[var(--muted)]">
        <span>{t('footer.beta')}</span>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link to="/ueber-uns" className="hover:text-[var(--text)]">
            {t('footer.about')}
          </Link>
          <Link to="/beta-guide" className="hover:text-[var(--text)]">
            {t('footer.betaGuide')}
          </Link>
          <Link to="/impressum" className="hover:text-[var(--text)]">
            {t('footer.impressum')}
          </Link>
          <Link to="/datenschutz" className="hover:text-[var(--text)]">
            {t('footer.privacy')}
          </Link>
        </div>
        <LanguageSwitcher />
      </div>
    </footer>
  );
}
